/**
 * The password rule, in one place (AVO-448, OWNER-DECISIONS §16.6).
 *
 * Every path that sets a password checks these: creating an account,
 * accepting an invitation, a reset, operator recovery and the account
 * portal's signup and reset. The web forms import this file by path, so their
 * copy and `minLength` cannot drift from what the server enforces.
 *
 * Signing in never checks length: a password set under an earlier, shorter
 * minimum keeps working until its owner changes it.
 *
 * No imports, so the browser bundles can take it as source.
 */
export const MIN_PASSWORD_LENGTH = 12;
export const MAX_PASSWORD_LENGTH = 200;
